import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://moga-dev.com/api",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      headers.set("Accept", "application/json");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),
    sendRegistrationOtp: builder.mutation({
      query: (phoneData) => ({
        url: "/v2/register/send-otp",
        method: "POST",
        body: phoneData,
      }),
    }),
    verifyRegistrationOtp: builder.mutation({
      query: (otpData) => ({
        url: "/v2/register/verify-otp",
        method: "POST",
        body: otpData,
      }),
    }),
    completeRegistration: builder.mutation({
      query: (registrationData) => ({
        url: "/v2/register/complete",
        method: "POST",
        body: registrationData,
      }),
    }),
    sendLoginOtp: builder.mutation({
      query: (phoneData) => ({
        url: "/v2/login-with-otp",
        method: "POST",
        body: phoneData,
      }),
    }),
    verifyLoginOtp: builder.mutation({
      query: (otpData) => ({
        url: "/v2/verify-login-otp",
        method: "POST",
        body: otpData,
      }),
    }),
    sendForgotPasswordOtp: builder.mutation({
      query: (phoneData) => ({
        url: "/v2/forgot-password",
        method: "POST",
        body: phoneData,
      }),
    }),
    resetPassword: builder.mutation({
      query: (resetData) => ({
        url: "/v2/reset-password",
        method: "POST",
        body: resetData,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useSendRegistrationOtpMutation,
  useVerifyRegistrationOtpMutation,
  useCompleteRegistrationMutation,
  useSendLoginOtpMutation,
  useVerifyLoginOtpMutation,
  useSendForgotPasswordOtpMutation,
  useResetPasswordMutation,
} = apiSlice;

export default apiSlice;
